<template>
  <div data-view="network-review">
    <layout-logged-frame has-before :title="$t('network_review')">
      <template v-slot:before>
        <NavigationTabs :tabs="navigationTabs"/>
      </template>

      <template v-slot:content>
        <NetworkFilters @filter="onFilter" @clearFilters="onClearFilters" />

        <table-base
          :columns="columns"
          :items="networks"
          :pages="totalPages"
          :pagination="pagination"
          has-custom-items-template
          :on-update-pagination="onUpdatePagination"
          :sync-to-url="true"
          @init-pagination="onInitPagination"
          :on-change-page="onChangePage"
        >
          <template v-slot:item-cell="scope">
            <template v-if="scope.cell.column.value === 'status.name'">
              <StatusSelect
                :item="scope.cell.item"
                :get-networks="getNetworks"
              />
            </template>

            <template v-else-if="scope.cell.column.value === 'updated_at'">
              {{ displayColumnDate(scope.cell.item, scope.cell.column.value) }}
            </template>

            <template v-else>
              <div class="cell-item">
                {{
                  displayColumnValue(scope.cell.item, scope.cell.column.value)
                }}
              </div>
            </template>
          </template>
        </table-base>
      </template>
    </layout-logged-frame>
  </div>
</template>

<script>
  import { isStr, extractNestedProp } from '../../utils';
  import columns from '../../config/networkReview/columns';
  import NetworkFilters from '../../components/forms/filters/NetworkReview';
  import urlPaginationRestore from '@/mixins/urlPaginationRestore';
  import StatusSelect from '../../components/panels/networkReview/StatusSelect';
  import navigationTabs from '../../config/billing/navigationTabs';
  import NavigationTabs from '../../components/NavigationTabs'

  export default {
    mixins: [urlPaginationRestore],
    components: {
      NetworkFilters,
      StatusSelect,
      NavigationTabs,
    },
    data() {
      return {
        columns,
        navigationTabs,
        query: { per_page: 15 },
        pagination: {
          order: 'asc',
          page: 1,
          rowsPerPage: 15,
          totalItems: 0,
        },
        totalPages: 1,
        isLoading: false,
      };
    },
    computed: {
      networks() {
        return this.$store.getters['networks/items'];
      },
    },
    created() {
      this.getStatuses();
    },
    methods: {
      getNetworks() {
        this.isLoading = true;

        return this.$store
          .dispatch('networks/getItems', this.query)
          .then((res) => {
            const { current_page, last_page, total } = res.itemsMeta;

            this.pagination.totalItems = total;
            this.pagination.page = current_page;
            this.totalPages = last_page;
            this.isLoading = false;

            return res;
          })
          .catch((err) => {
            this.isLoading = false;
            return err;
          });
      },
      getStatuses() {
        return this.$store.dispatch('networks/getStatuses');
      },
      displayColumnValue(item, columnValue) {
        return extractNestedProp(item, columnValue) || '-';
      },
      displayColumnDate(item, columnValue) {
        const extractedDate = extractNestedProp(item, columnValue);
        return isStr(extractedDate)
          ? this.$dayjs(extractedDate).format('YYYY-MM-DD HH:mm:ss')
          : '-';
      },
      onUpdatePagination({ page, order, sortBy }) {
        this.pagination.page = page;
        this.pagination.order = order;
        this.pagination.sortBy = isStr(sortBy) ? sortBy : this.pagination.sortBy;

        this.query = {
          ...this.query,
          page,
          order,
          ...(isStr(sortBy) ? { sort: sortBy } : {}),
        };

        this.runInitialFetch(() => this.getNetworks());
      },
      onChangePage(page) {
        this.pagination.page = page;
        this.query = { ...this.query, page };
        this.getNetworks();
      },
      onFilter(filters) {
        this.pagination.page = 1;
        this.query = { ...this.query, ...filters, page: 1 };
        this.runInitialFetch(() => this.getNetworks());
      },
      onClearFilters() {
        const { order, sortBy } = this.pagination;
        this.pagination.page = 1;
        this.query = {
          per_page: 15,
          page: 1,
          order,
          ...(isStr(sortBy) ? { sort: sortBy } : {}),
        };
        this.getNetworks();
      },
    },
  };
</script>

<style lang="scss">
[data-view='network-review'] {
  .cell-item {
    line-height: 24px;
  }
}
</style>
